import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { SearchAccountHeadMasterComponent } from './search-account-head-master/search-account-head-master.component';
import { BranchMatserService } from 'app/masters/branch-matser.service';
import { DashboardService } from 'app/dashboard/dashboard.service';
import { AccountHeadMasterModel } from 'app/masters/models/account-master.model';

@Component({
  selector: 'app-account-head-master',
  templateUrl: './account-head-master.component.html',
  styleUrls: ['./account-head-master.component.scss']
})
export class AccountHeadMasterComponent implements OnInit {
  AccountHeadMasterModeldata: AccountHeadMasterModel[] = [];
  accountHeadMasterModelobj: AccountHeadMasterModel = {};
  constructor(public dialog: MatDialog, public branchMatserService: BranchMatserService, public dashboardservice: DashboardService) { }

  ngOnInit(): void {
    this.GetAccountHeadMaster(0);
    this.cleardata();
  }
  GetAccountHeadMaster(parameter) {
    this.branchMatserService.GetAccountHeadMaster(parameter).subscribe((x: any) => {
      this.AccountHeadMasterModeldata = [];
      this.AccountHeadMasterModeldata = x;
    }, err => {
      if (err.status == 403) {
        this.dashboardservice.openSnackBar("You Don't have Permission", "OK");
      }
      else if (err.error.statusCode == 422) {
        this.dashboardservice.openSnackBar(err.error.message, "OK");
      }
      else {
        this.dashboardservice.openSnackBar("API Failed", "OK");
      }
    });
  }
  /** Search Account Master */
  searchAccountHeadMaster() {
    const dialogRef = this.dialog.open(SearchAccountHeadMasterComponent, {
      panelClass: "full-width-dialog",
      // maxWidth: "100vw !important",
      width: "80%",
      height: "75%",
      disableClose: true,
      data: this.AccountHeadMasterModeldata
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result != null && result != undefined && result != 0) {
        this.accountHeadMasterModelobj = {};
        this.accountHeadMasterModelobj = JSON.parse(JSON.stringify(result));
       
        this.accountHeadMasterModelobj.isEdit = true;
      }
    });
  }

  cleardata() {
    this.accountHeadMasterModelobj = {};
    this.accountHeadMasterModelobj.accountHeadName = '';
    this.accountHeadMasterModelobj.pK_AccountHeadId = 0;
    this.accountHeadMasterModelobj.isEdit = false;
    this.accountHeadMasterModelobj.isActive = false;
    this.accountHeadMasterModelobj.fK_AccountHeadId = 1;
  }
  saveAccountMaster(event) {
    let checkdublicatedata = this.AccountHeadMasterModeldata.filter(item => item.accountHeadName.toLowerCase() == this.accountHeadMasterModelobj.accountHeadName.toLowerCase());
    if (checkdublicatedata.length == 0 || this.accountHeadMasterModelobj.pK_AccountHeadId > 0) {
      const button = (event.srcElement.disabled === undefined) ? event.srcElement.parentElement : event.srcElement;
      button.setAttribute('disabled', true);
    //    setTimeout(function () {
    //   button.removeAttribute('disabled');
    // }, 2000);

      let payload = {
        "AccountHeadMaster": this.accountHeadMasterModelobj
      }
      this.branchMatserService.InsertAccountHeadMaster(payload).subscribe((x: any) => {
        this.GetAccountHeadMaster(0);
        this.cleardata();
        if (this.accountHeadMasterModelobj.pK_AccountHeadId > 0) {
          this.dashboardservice.openSnackBar("Record Updated Successfully", "ok");
        } else {
          this.dashboardservice.openSnackBar("Record Saved Successfully", "ok");
        }
      }, err => {
        button.removeAttribute('disabled');
        this.cleardata();
        if (err.status == 403) {
          this.dashboardservice.openSnackBar("You Don't have Permission", "OK");
        }
        else if (err.error.statusCode == 422) {
          this.dashboardservice.openSnackBar(err.error.message, "OK");
        }
        else {
          this.dashboardservice.openSnackBar("API Failed", "OK");
        }
      });
    } else {
      this.dashboardservice.openSnackBar("Record Already Exists", "ok");
    }
  }
}
